import { getFeaturebaseJwt } from "@/api/privateRequests/user/getFeaturebaseJwt";
import {
  FEATUREBASE_SSO_BASE_URL,
  FEEDBACK_PORTAL_RETURN_URL,
} from "@/settings";
import { type TranslateFn, t } from "@repo/shared/i18n";

const validHosts = ["featurebase.app", "feedback.easysbc.io"];
export const FEEDBACK_PORTAL_DISPLAY_NAME_REGEX =
  /^(?=.*[A-Za-z0-9])[A-Za-z0-9 _-]{3,30}$/;

export const normalizeReturnUrl = (url: string): string => {
  try {
    const parsedUrl = new URL(url);
    // Strip trailing "/u/{some-long-string}" pattern
    const pathname = parsedUrl.pathname;
    const uPatternMatch = pathname.match(/^(.*)\/u\/[^/]+$/);
    if (uPatternMatch) {
      parsedUrl.pathname = uPatternMatch[1] || "/";
      return parsedUrl.toString();
    }
    return url;
  } catch {
    return url;
  }
};

export const isValidReturnUrl = (url: string): boolean => {
  try {
    const parsedUrl = new URL(url);
    if (parsedUrl.protocol !== "https:") {
      return false;
    }

    // Check for exact match or valid subdomain (must end with '.' + host)
    return validHosts.some((host) => {
      const hostname = parsedUrl.hostname;
      return hostname === host || hostname.endsWith(`.${host}`);
    });
  } catch {
    return false;
  }
};

export const validateFeedbackPortalDisplayName = (rawDisplayName: string) => {
  const trimmed = rawDisplayName.trim();
  const isValid = FEEDBACK_PORTAL_DISPLAY_NAME_REGEX.test(trimmed);

  return {
    trimmed,
    isValid,
    error: isValid
      ? null
      : (t as TranslateFn<["common", "auth"]>)(
          "auth:featurebase.displayNameRule",
        ),
  };
};

export const buildFeaturebaseRedirectUrl = async (
  returnTo: string = FEEDBACK_PORTAL_RETURN_URL,
) => {
  const { jwt } = await getFeaturebaseJwt();
  const featurebaseUrl = new URL(FEATUREBASE_SSO_BASE_URL);
  featurebaseUrl.searchParams.set("jwt", jwt);
  featurebaseUrl.searchParams.set("return_to", returnTo);
  return featurebaseUrl.toString();
};
